<template>
  <div class="card mb-4 shadow-sm">
    <div class="card-body">
      <div style="text-align: center">
        <img
          style="max-width: 250px !important; text-align: 'center'"
          :src="product.cover"
          class="img img-responsive text-center"
        />
      </div>
      <br />
      <b class="text-left">{{ product.name }}</b>
      <table class="table table-responsive">
        <tr>
          <td style="text-align: left;">Individual</td>
          <td style="text-align: right;">
            <money-format
              :value="product.price"
              :locale="locale"
              :currency-code="currencyCode"
              :subunits-value="false"
              :hide-subunits="true"
              style="padding-right: 0 !important"
            >
            </money-format>
          </td>
        </tr>
        <tr>
          <td style="text-align: left; padding-left: 0 !important; font-weight: bold;">
            Grupal
          </td>
          <td style="text-align: right; padding-right: 0 !important; font-weight: bold; ">
            <money-format
              :value="product.group_price"
              :locale="locale"
              :currency-code="currencyCode"
              :subunits-value="false"
              :hide-subunits="true"
              style="padding-right: 0 !important"
            >
            </money-format>
          </td>
        </tr>
      </table>
      <button
            type="button"
            style="width: 100%; display: inline; font-weight: bold"
            class="btn btn-outline btn-outline-dark btn-active-light-dark"
            v-on:click="goToBack()"
          >
            Ver producto
          </button>
    </div>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";

export default {
  components: {
    "money-format": MoneyFormat,
  },
  name: "product",
  props: ["product"],
  mounted() {},
  data() {
    return {
      currencyCode: "USD",
      locale: "en"
    };
  },
  methods: {
    goToProductDetail(){
      this.$router.push({
        path: `product-detail/${this.product.id}`,
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
